import ResponseParseError from './ResponseParseError';
export default class JSONResponseParseError extends ResponseParseError {
    constructor(response, originalError) {
        super(response, originalError);
        this.response = response;
        this.originalError = originalError;
        this.name = 'JSONResponseParseError';
    }
}
